import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { getAuth } from "firebase/auth";

const GenerateShareLinkButton = ({ projectId }) => {
  const [shareUrl, setShareUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState("");
  const [expiresInDays, setExpiresInDays] = useState(7); // default 7 dana
  

  const handleGenerate = async () => {
  setLoading(true);
  setCopied(false);
  setError("");

  try {
    const auth = getAuth();
    const token = auth.currentUser ? await auth.currentUser.getIdToken() : "";

    const response = await axios.post(
      "https://modularobjects.com/checkout/api/project-share/generate",
      {
        projectId,
        expiresInDays
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data?.shareUrl) {
      setShareUrl(response.data.shareUrl);
    } else {
      setError("Link nije generisan.");
    }
  } catch (err) {
    console.error("Greška:", err);
    setError("Greška prilikom generisanja linka.");
  } finally {
    setLoading(false);
  }
};


  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Greška prilikom kopiranja:", err);
    }
  };

  const [existingLinks, setExistingLinks] = useState([]);

useEffect(() => {
  const fetchLinks = async () => {
    try {
      const auth = getAuth();
      const token = auth.currentUser ? await auth.currentUser.getIdToken() : "";

      const response = await axios.get(
        `https://modularobjects.com/checkout/api/project-share/list/${projectId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setExistingLinks(response.data.links);
    } catch (err) {
      console.error("Greška prilikom preuzimanja linkova:", err);
    }
  };

  if (projectId) {
    fetchLinks();
  }
}, [projectId]);


  return (
    <div className="space-y-2 mt-4">
      <div className="flex items-center gap-2">
        <label htmlFor="days" className="text-sm font-medium">Trajanje linka:</label>
        <select
          id="days"
          className="border px-2 py-1 rounded"
          value={expiresInDays}
          onChange={(e) => setExpiresInDays(Number(e.target.value))}
        >
          <option value={1}>1 dan</option>
          <option value={3}>3 dana</option>
          <option value={7}>7 dana</option>
          <option value={15}>15 dana</option>
          <option value={30}>30 dana</option>
        </select>
      </div>

      <button
        onClick={handleGenerate}
        disabled={loading}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        {loading ? "Generisanje..." : "Generiši link za deljenje"}
      </button>

      {shareUrl && (
        <div className="bg-gray-100 p-2 rounded border flex items-center justify-between">
          <span className="text-sm break-all">{shareUrl}</span>
          <button
            onClick={copyToClipboard}
            className="ml-4 px-2 py-1 bg-green-500 text-white rounded hover:bg-green-600"
          >
            {copied ? "Kopirano!" : "Kopiraj"}
          </button>
        </div>
      )}

      {error && <div className="text-red-600 text-sm">{error}</div>}

{existingLinks.length > 0 && (
  <div className="mt-4">
    <h3 className="text-lg font-semibold mb-2">Postojeći linkovi:</h3>
    <ul className="space-y-2 text-sm">
      {existingLinks.map((link, idx) => (
        <li key={idx} className="bg-gray-100 p-2 rounded flex justify-between items-center">
          <span className="break-all">
            https://modularobjects.com/share/project/{link.share_token}
          </span>
          <span className="ml-4 text-xs text-gray-600">
            Ističe: {new Date(link.expires_at).toLocaleDateString()}
          </span>
        </li>
      ))}
    </ul>
  </div>
)}


    </div>


    
  );
};

export default GenerateShareLinkButton;
